// Rol uchun jadval ustunlari ko'rinishini boshqarishda ishlatiladigan ta'riflar.
import { GENERATED_MODULE_COLUMNS } from "./moduleColumns.generated"
// key — ustunning kaliti (dataIndex), label — jadvaldagi sarlavha (title) bilan mos bo'lishi kerak.

export const MODULE_NAMES: Record<string, string> = {
  home: "Главная панель",
  // Egasi (2026-09-02): «barcha bo'limlar rollar oynasida ko'rinsin» — users qatori nomsiz (usersusers) chiqardi
  users: "Пользователи",
  globalPanel: "Глобальная панель",
  orderToMain: "Заказ поставщику",
  sales: "Продажи",
  purchases: "Закупки",
  factoryPurchases: "Закупка завода",
  expenses: "Закупка расход",
  returnSales: "Возврат продажи",
  returnPurchases: "Возврат закупки",
  defects: "Брак",
  transfers: "Перемещение",
  products: "Товары",
  discountedProducts: "Скидки",
  residues: "Остатки",
  moneys: "Касса (Деньги)",
  counterparties: "Контрагенты",
  warehouses: "Склады",
  showcases: "Витрина",
  factories: "Заводы",
  orders: "Заказы",
  moneyComments: "Чат сообщений",
  orderComments: "Заказ чат",
  managers: "Менеджеры",
  roles: "Роли и права",
  recent: "Контроль (Аудит)",
  reports: "Отчеты",
  trash: "Корзина",
  auditLogs: "Логи действий",
  backups: "Резервные копии (Бэкап)",
  dataAdmin: "Управление данными",
  // 6-7 bosqich modullari
  employees: "Сотрудники (HR)",
  kpi: "KPI",
  declarations: "Декларации",
  contracts: "Договоры",
  deliveries: "Логистика",
  shops: "Магазины",
  customers: "Клиенты",
  partnerApplications: "Заявки партнёров",   // tog'a #3563 2-qism
  // Bazadagi resurs nomlari uchun taxalluslar
  transferLog: "Перемещение",
  productDiscount: "Скидки",
}

// tog'a #1885 (2026-09-13): QO'LDA ta'rif — faqat maxsus holatlar (data.tsx'da bo'lmagan jadvallar, moslik kalitlari).
// Asosiy manba — scripts/gen_module_columns.js (src/pages/**/data.tsx dan avtomatik, prebuild): moduleColumns.generated.ts
const MANUAL_MODULE_COLUMNS: Record<string, { key: string; label: string }[]> = {
  sales: [
    { key: "dateSale", label: "Дата продажи" },
    { key: "document", label: "Документ" },
    { key: "mainProduct", label: "Товар" },
    { key: "article", label: "Артикул" },
    { key: "productType", label: "Тип товара" },
    { key: "barCode", label: "Штрих-код" },
    { key: "mainCounterparty", label: "Контрагент" },
    { key: "amount", label: "Количество" },
    { key: "priceUSD", label: "Цена ($)" },
    { key: "totalPriceUSD", label: "Сумма ($)" },
    { key: "mainWarehouse", label: "Склад" },
  ],
  purchases: [
    { key: "datePurchase", label: "Дата закупки" },
    { key: "document", label: "Документ" },
    { key: "status", label: "Статус" },
    { key: "mainProduct", label: "Товар" },
    { key: "productType", label: "Тип товара" },
    { key: "barCode", label: "Штрих-код" },
    { key: "article", label: "Артикул" },
    { key: "mainFactory", label: "Завод" },
    { key: "amount", label: "Количество" },
    { key: "priceUSD", label: "Цена ($)" },
    { key: "totalPriceUSD", label: "Сумма ($)" },
    { key: "mainWarehouse", label: "Склад" },
  ],
  products: [
    { key: "photo", label: "Фото" },
    { key: "nameModel", label: "Название товара" },
    { key: "barCode", label: "Штрих-код" },
    { key: "article", label: "Артикул" },
    { key: "productType", label: "Тип товара" },
    { key: "productCategory", label: "Категория" },
    { key: "productUnit", label: "Ед. изм." },
    { key: "purchaseUSD", label: "Цена закупки ($)" },
    { key: "costPriceUSD", label: "Себестоимость ($)" },
    { key: "salePriceUSD", label: "Цена продажи ($)" },
  ],
  residues: [
    { key: "nameModel", label: "Товар" },
    { key: "lastPurchaseDocument", label: "Последний документ закупки" },
    { key: "barCode", label: "Штрих-код" },
    { key: "article", label: "Артикул" },
    { key: "productType", label: "Тип товара" },
    { key: "purchaseUSD", label: "Цена закупки ($)" },
    { key: "saleUSD", label: "Последняя продажа ($)" },
    { key: "costPriceUSD", label: "Себестоимость ($)" },
    { key: "costPriceUZS", label: "Себестоимость (сум)" },
    { key: "showcaseCount", label: "Витрина" },
    { key: "returnPurchaseCount", label: "Возврат закупки" },
    { key: "totalCount", label: "Остаток (всего)" },
    { key: "reservedCount", label: "Забронировано" },
    { key: "inTransitCount", label: "В пути" },
    { key: "totalPriceUSD", label: "Сумма ($)" },
  ],
  transfers: [
    { key: "date", label: "Дата перемещения" },
    { key: "mainProduct", label: "Товар" },
    { key: "amount", label: "Количество" },
    { key: "warehouseFrom", label: "Откуда" },
    { key: "warehouseTo", label: "Куда" },
    { key: "comment", label: "Комментарий" },
  ],
  counterparties: [
    { key: "name", label: "Имя" },
    { key: "lastname", label: "Фамилия" },
    { key: "phone", label: "Телефон" },
    { key: "email", label: "Email" },
    { key: "address", label: "Адрес" },
    { key: "debt", label: "Долг" },
  ],
  moneys: [
    { key: "date", label: "Дата операции" },
    { key: "counterparty", label: "Контрагент" },
    { key: "amountUSD", label: "Сумма ($)" },
    { key: "amountUZS", label: "Сумма (сум)" },
    { key: "paymentType", label: "Тип оплаты" },
    { key: "purposePayment", label: "Назначение" },
    { key: "comment", label: "Комментарий" },
  ],
  // Возврат продажи va Брак (defects) bitta jadval komponentini ishlatadi —
  // ikkalasi uchun ham bir xil ustunlar ro'yxati
  returnSales: [
    { key: "dateReturnSale", label: "Дата возврата продажи" },
    { key: "document", label: "Документа" },
    { key: "mainWarehouse", label: "Склад" },
    { key: "mainUsers", label: "Автор" },
    { key: "mainCounterparty", label: "Контрагент" },
    { key: "article", label: "Артикул" },
    { key: "barCode", label: "Штрих-код" },
    { key: "amount", label: "Кол-во" },
    { key: "priceUSD", label: "Сумма y.e" },
    { key: "photo", label: "Фото" },
  ],
  defects: [
    { key: "dateReturnSale", label: "Дата возврата продажи" },
    { key: "document", label: "Документа" },
    { key: "mainWarehouse", label: "Склад" },
    { key: "mainUsers", label: "Автор" },
    { key: "mainCounterparty", label: "Контрагент" },
    { key: "article", label: "Артикул" },
    { key: "barCode", label: "Штрих-код" },
    { key: "amount", label: "Кол-во" },
    { key: "priceUSD", label: "Сумма y.e" },
    { key: "photo", label: "Фото" },
  ],
  returnPurchases: [
    { key: "dateReturnPurchase", label: "Дата Возврат закупки" },
    { key: "document", label: "Документа" },
    { key: "datePurchase", label: "Дата закупки" },
    { key: "warehouse", label: "Склад" },
    { key: "article", label: "Артикул" },
    { key: "barCode", label: "Штрих-код" },
    { key: "amount", label: "Кол-во" },
    { key: "priceUSD", label: "Сумма y.e" },
  ],
  factoryPurchases: [
    { key: "datePurchase", label: "Дата закупки" },
    { key: "document", label: "Документа" },
    { key: "status", label: "Статус" },
    { key: "product", label: "Товар" },
    { key: "article", label: "Артикул" },
    { key: "barCode", label: "Штрих-код" },
    { key: "mainWarehouse", label: "Склад" },
    { key: "mainFactory", label: "Завод" },
    { key: "mainUsers", label: "Автор" },
    { key: "amount", label: "Кол-во" },
    { key: "totalPriceUSD", label: "Сумма y.e" },
  ],
  discountedProducts: [
    { key: "nameModel", label: "Имя модель" },
    { key: "article", label: "Артикул" },
    { key: "purchaseUSD", label: "Закупка у.е" },
    { key: "costPriceUSD", label: "Себестоимость у.е" },
    { key: "salePriceUSD", label: "Цена продажи ($)" },
    { key: "discount", label: "Скидка %" },
    { key: "discountBegin", label: "Время начала" },
    { key: "discountEnd", label: "Время окончания" },
  ],
  // Boshliq (2026-09-13, tog'a #1870): tovar ustunlari kimga ko'rinishini admin belgilaydi — shu ikki bo'lim ham sozlanadi
  globalPanel: [
    { key: "barCode", label: "Штрих-код" },
    { key: "article", label: "Артикул" },
  ],
  orderToMain: [
    { key: "barCode", label: "Штрих-код" },
    { key: "article", label: "Артикул" },
  ],
  orders: [
    { key: "document", label: "Документа" },
    { key: "dateOrder", label: "Дата заказа" },
    { key: "amount", label: "Количество" },
    { key: "mainCounterparty", label: "Контрагент" },
    { key: "product", label: "Товар" },
    { key: "barCode", label: "Штрих-код" },
    { key: "article", label: "Артикул" },
    { key: "status", label: "Статус" },
  ],
  warehouses: [
    { key: "name", label: "Названия" },
    { key: "selected", label: "Основной склад" },
    { key: "address", label: "Адрес" },
    { key: "status", label: "Статус" },
    { key: "inserted", label: "Вставлен" },
    { key: "updated", label: "Обновлён" },
  ],
  showcases: [
    { key: "count", label: "Количество" },
    { key: "inserted", label: "Дата" },
    { key: "counterparty", label: "Контрагент" },
    { key: "counterpartyEmail", label: "Почта контрагента" },
    { key: "phone", label: "Телефон" },
    { key: "address", label: "Адрес" },
  ],
  factories: [
    { key: "name", label: "Названия" },
    { key: "debt", label: "Баланс / Долг" },
    { key: "phone", label: "Телефон" },
    { key: "email", label: "Почта" },
    { key: "address", label: "Адрес" },
    { key: "inserted", label: "Вставлен" },
  ],
  employees: [
    { key: "firstName", label: "Имя" },
    { key: "position", label: "Должность" },
    { key: "department", label: "Отдел" },
    { key: "phone", label: "Телефон" },
    { key: "baseSalaryUSD", label: "Базовый оклад ($)" },
    { key: "status", label: "Статус" },
  ],
  deliveries: [
    { key: "driverName", label: "Водитель" },
    { key: "driverPhone", label: "Телефон" },
    { key: "vehicleInfo", label: "Транспорт" },
    { key: "route", label: "Маршрут" },
    { key: "inserted", label: "Дата" },
    { key: "status", label: "Статус" },
  ],
  shops: [
    { key: "name", label: "Название" },
    { key: "address", label: "Адрес" },
    { key: "phone", label: "Телефон" },
    { key: "mainWarehouse", label: "Склад" },
    { key: "status", label: "Статус" },
  ],
  customers: [
    { key: "name", label: "Имя" },
    { key: "phone", label: "Телефон" },
    { key: "segment", label: "Сегмент" },
    { key: "totalPurchasedUSD", label: "Всего покупок ($)" },
    { key: "debtUSD", label: "Долг" },
    { key: "purchasesCount", label: "Кол-во покупок" },
    { key: "bonusBalance", label: "Бонусный баланс" },
  ],
  contracts: [
    { key: "contractNumber", label: "Номер договора" },
    { key: "mainFactory", label: "Завод" },
    { key: "amountUSD", label: "Сумма ($)" },
    { key: "startDate", label: "Начало" },
    { key: "endDate", label: "Окончание" },
    { key: "status", label: "Статус" },
  ],
  declarations: [
    { key: "document", label: "Документ закупки" },
    { key: "dateDeclaration", label: "Дата" },
    { key: "comment", label: "Комментарий" },
    { key: "status", label: "Статус" },
  ],
}

// Birlashma: qo'lda kiritilgan ustun (label bo'yicha) ustun turadi — saqlangan rol sozlamalari o'sha kalitlarga (barCode, article,
// mainProduct…) tayanadi; avtomatik ta'rifdan faqat qo'lda YO'Q sarlavhalar qo'shiladi (kalit to'qnashsa — label bilan ajratiladi).
const mergeDefs = (): Record<string, { key: string; label: string }[]> => {
  // Qoida (2026-09-13 jonli sabog'i): LABEL — avtomatik (jadval sarlavhasi bilan aynan bir xil, TableExtended shu bo'yicha topadi);
  // KALIT — qo'lda ta'rifdagi mos yozuvdan (label yoki dataIndex bo'yicha) — saqlangan rol sozlamalari (col:barCode…) buzilmasin.
  // Qo'lda yozuv hech qaysi avtomatik yozuvga mos kelmasa (funksiya/JSX sarlavhali ustun) — o'zicha qo'shiladi.
  const out: Record<string, { key: string; label: string }[]> = {}
  const mods = Array.from(new Set([...Object.keys(MANUAL_MODULE_COLUMNS), ...Object.keys(GENERATED_MODULE_COLUMNS)]))
  const slug = (t: string) => t.toLowerCase().replace(/[^a-zа-яё0-9]+/gi, "_")
  for (const m of mods) {
    const manual = [...(MANUAL_MODULE_COLUMNS[m] || [])]
    const used = new Set<number>()
    const list: { key: string; label: string }[] = []
    for (const g of GENERATED_MODULE_COLUMNS[m] || []) {
      if (list.some((c) => c.label === g.label)) continue
      let mi = manual.findIndex((c, i) => !used.has(i) && c.label === g.label)
      if (mi < 0) mi = manual.findIndex((c, i) => !used.has(i) && c.key === g.key.split(":")[0])
      const baseKey = mi >= 0 ? manual[mi].key : g.key
      if (mi >= 0) used.add(mi)
      const key = list.some((c) => c.key === baseKey) ? baseKey + ":" + slug(g.label) : baseKey
      list.push({ key, label: g.label })
    }
    manual.forEach((c, i) => {
      if (used.has(i) || list.some((x) => x.label === c.label)) return
      const key = list.some((x) => x.key === c.key) ? c.key + ":" + slug(c.label) : c.key
      list.push({ key, label: c.label })
    })
    out[m] = list
  }
  return out
}
export const MODULE_COLUMNS_DEFINITION: Record<string, { key: string; label: string }[]> = mergeDefs()
/** rolning yashirilgan ustunlari: hiddenFeatures ichidagi "col:<key>" (yangi) yoki eski whitelist (columns) — def − columns */
export const hiddenColumnKeys = (perm: any, def: { key: string; label: string }[]): Set<string> => {
  const feats: string[] = Array.isArray(perm?.hiddenFeatures) ? perm.hiddenFeatures : []
  const fromCol = feats.filter((f) => typeof f === "string" && f.startsWith("col:")).map((f) => f.slice(4))
  if (fromCol.length) return new Set(fromCol)
  const allowed = perm?.columns
  if (Array.isArray(allowed)) return new Set(def.filter((c) => !allowed.includes(c.key)).map((c) => c.key))
  return new Set()
}

// Har bir modul ichida rolga qarab yoqish/o'chirish mumkin bo'lgan funksiyalar.
// Belgilanmagan (checked) funksiya ko'rinadi; olib tashlanganlari hiddenFeatures sifatida saqlanadi.
export const MODULE_FEATURES_DEFINITION: Record<string, { key: string; label: string }[]> = {
  sales: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
    { key: "filter", label: "Кнопка Фильтр" },
    { key: "invoice", label: "Кнопка Invoice" },
  ],
  purchases: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "import", label: "Импорт (Excel)" },
    { key: "summary", label: "Строка Итого" },
    { key: "filter", label: "Кнопка Фильтр" },
    { key: "setPrices", label: "Кнопка «$» Установка цены продажи" },   // Boshliq «Menejer huquqlari» (2026-09-14)
  ],
  factoryPurchases: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
    { key: "filter", label: "Кнопка Фильтр" },
  ],
  returnSales: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
    { key: "filter", label: "Кнопка Фильтр" },
    { key: "residues", label: "Кнопка Остатки" },   // Boshliq «Menejer huquqlari» (2026-09-14)
  ],
  returnPurchases: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
    { key: "filter", label: "Кнопка Фильтр" },
  ],
  defects: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
    { key: "filter", label: "Кнопка Фильтр" },
  ],
  transfers: [
    { key: "summary", label: "Строка Итого" },
    { key: "filter", label: "Кнопка Фильтр" },
    { key: "shortages", label: "Кнопка Недостачи перевода" },   // Boshliq «Menejer huquqlari» (2026-09-14)
  ],
  products: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "import", label: "Импорт (Excel)" },
    { key: "summary", label: "Строка Итого" },
  ],
  discountedProducts: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
  ],
  residues: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
  ],
  counterparties: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
  ],
  moneys: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
    { key: "filter", label: "Кнопка Фильтр" },
  ],
  orders: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
    { key: "residues", label: "Кнопка Остатки" },   // Boshliq «Menejer huquqlari» (2026-09-14)
    { key: "filter", label: "Кнопка Фильтр" },
  ],
  warehouses: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
  ],
  showcases: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
  ],
  factories: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
  ],
  employees: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
  ],
  deliveries: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
  ],
  shops: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
  ],
  customers: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
  ],
  contracts: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
    { key: "summary", label: "Строка Итого" },
  ],
  declarations: [
    { key: "export", label: "Экспорт (Excel/PDF)" },
  ],
  reports: [
    { key: "tab_sale", label: "Отчет: Продажи" },
    { key: "tab_reportCounterparties", label: "Отчет: Контрагенты" },
    { key: "tab_indicators", label: "Отчет: Показатели" },
    { key: "tab_financialReport", label: "Финансовый отчет" },
    { key: "tab_netProfit", label: "Чистая прибыль" },
    { key: "tab_overdueDebts", label: "Просроченная задолженность" },
    { key: "tab_paymentsByProduct", label: "Оплата по товарам" },
  ],
}
